import { render, staticRenderFns } from "./reporteUtilidades.vue?vue&type=template&id=36d48b5b&"
import script from "./reporteUtilidades.vue?vue&type=script&lang=js&"
export * from "./reporteUtilidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports